(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Recall_statusDetailController', Recall_statusDetailController);

    Recall_statusDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Recall_status'];

    function Recall_statusDetailController($scope, $rootScope, $stateParams, previousState, entity, Recall_status) {
        var vm = this;

        vm.recall_status = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:recall_statusUpdate', function(event, result) {
            vm.recall_status = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
